var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-6" },
    [
      _c(
        "router-link",
        {
          staticClass: "no-underline",
          attrs: {
            to: { name: "resource-basics", params: { id: _vm.resource.id } },
          },
        },
        [
          _c("img", {
            staticClass: "rounded-lg shadow-lg",
            staticStyle: { height: "218px", "object-fit": "cover" },
            attrs: {
              alt: _vm.resource.title,
              src: _vm.resource.image
                ? _vm.resource.image + "?auto=format&fit=crop&h=619&w=1024"
                : "/img/hems-placeholder.png",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pt-2", class: _vm.statusClasses }, [
        _vm._v("\n    " + _vm._s(_vm.statusText) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "resource-spacer" }),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "text-2xl font-sans text-n-gray-dark font-hairline" },
        [
          _c(
            "router-link",
            {
              staticClass: "no-underline",
              attrs: {
                to: {
                  name: "resource-basics",
                  params: { id: _vm.resource.id },
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.resource.title) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "resource-spacer" }),
      _vm._v(" "),
      _c("p", [_vm._v("\n    " + _vm._s(_vm.resource.teaser) + "\n  ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }